import { Stack as MuiStack, StackProps as MuiStackProps } from '@mui/material';
import { CommonDataProps } from '../../utils';

export type StackProps<D extends React.ElementType = 'div', P = object> = MuiStackProps<D, P> & CommonDataProps;

export const Stack = MuiStack;
